import styled from "styled-components";
import AppBar from "@material-ui/core/AppBar";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import GetAppIcon from "@material-ui/icons/GetApp";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  WHITE_COLOR,
  BAR_FILLED,
  PRIMARY_COLOR,
  DARK_GRAY,
  UNICEF_GREEN,
  LIGHT_GRAY,
  BLACK_COLOR,
  RED_COLOR,
} from "../../constants/color";

export const GridTableWrapper = styled.div`
  padding: 10px 0;
`;

export const detailsPannel = {
  backgroundColor: "#E0F2F9",
};

export const BoxShadowWrapper = styled.div`
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
  border: 1px solid #d1d6e0;
  border-radius: 2px;
  background-color: ${WHITE_COLOR};
  margin-bottom: 20px;
`;

export const SubHeaderWrapper = styled.div`
  padding: 10px 0;
`;

export const DownloadIconCustom = styled(GetAppIcon)`
  && {
    margin-right: 10px;
    width: 18px;
    height: 18px;
  }
`;

export const ArrowBackIosIconCustom = styled(ArrowBackIosIcon)`
  && {
    color: ${BAR_FILLED};
    width: 16px;
    height: 16px;
  }
`;

export const ScmmAppBar = styled(AppBar)`
  && {
    background-color: ${WHITE_COLOR} !important;
    box-shadow: none;

    button {
      color: ${DARK_GRAY} !important;
      text-transform: capitalize;
      font-size: 14px;
      font-weight: 400;
      opacity: 1;
    }
    .MuiTab-textColorInherit.Mui-selected {
      font-weight: 700;
    }
    .MuiTabs-indicator {
      background-color: ${PRIMARY_COLOR};
    }
  }
`;

export const ActiveStatus = styled.span`
  display: inline-block;
  vertical-align: bottom;
  width: 18px;
  height: 18px;
  background-color: rgb(${UNICEF_GREEN});
  border-radius: 50%;
  border: 1px solid transparent;
`;

export const InActiveStatus = styled.span`
  display: inline-block;
  vertical-align: bottom;
  width: 18px;
  height: 18px;
  background-color: #f1f1f1;
  border-radius: 50%;
  border: 1px solid transparent;
`;

export const ARStatus = styled.span`
  display: inline-block;
  vertical-align: bottom;
  width: 18px;
  height: 18px;
  background-color: transparent;
  border-radius: 50%;
  border: 1px solid #c9c9c9;
`;

export const UserProfileTab = styled.div`
  && {
    @media screen and (max-width: 1080px) {
      > .MuiGrid-container {
        flex-direction: column-reverse;
        > .MuiGrid-root.MuiGrid-item {
          width: 100%;
        }
      }
      .paddingR20 {
        padding: 20px;
      }
    }
  }
`;

export const CustomTable = styled.table`
  && {
    width: 100%;
    border-spacing: 0;

    th,
    td {
      padding: 10px 15px;
      border-bottom: 1px solid ${WHITE_COLOR};
    }
  }
`;

export const EditIconCustom = styled(EditIcon)`
  && {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;
export const AddIconCustom = styled(AddIcon)`
  && {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;
export const DeleteIconCustom = styled(DeleteIcon)`
  && {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;

export const WarningLabel = styled.span`
  && {
    color: ${RED_COLOR};
    font-size: 12px !important;
    margin-bottom: 7px;
    display: block;
  }
`;

export const BigContainer = styled.div`
  && {
    min-height: 400px;
  }
`;

export const CustomDevider: any = styled.hr`
  && {
    margin: 0;
    border: 1px solid #f0f0f0 !important;
  }
`;

export const GreenFormControlLabel = styled(FormControlLabel)`
  && {
    position: relative;
    .MuiSwitch-root {
      margin-left: 40px;
    }
    .MuiSwitch-colorSecondary.Mui-checked {
      color: rgb(${UNICEF_GREEN});
    }
    .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
      background-color: rgba(${UNICEF_GREEN}, 0.5);
    }
    .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1 {
      position: absolute;
      left: 0;
      font-size: 14px;
    }
  }
`;

export const BlueSubHeader = styled.div`
  background-color: #e0f2f9;
  padding: 10px 15px;

  strong {
    font-weight: 500 !important;
  }
`;

export const UserContainer = styled.div`
  && {
    width: 95%;
    margin: 0 auto;
    padding: 15px 0;

    @media screen and (max-width: 1080px) {
      width: 90%;
    }
  }
`;

export const AddRoleButton = styled(Button)`
  && {
    color: #374ea1;
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
  }
`;

export const DialogButtonDefault = styled(Button)`
  && {
    background-color: ${LIGHT_GRAY} !important;
    color: ${BLACK_COLOR} !important;
    text-transform: capitalize;
  }
`;

export const DialogButtonPrimary = styled(Button)`
  && {
    background-color: ${PRIMARY_COLOR} !important;
    &.MuiButton-contained.Mui-disabled {
      background-color: rgba(0, 0, 0, 0.12) !important;
      color: rgba(0, 0, 0, 0.26) !important;
    }
  }
`;
